// Area de cada modulo em Configuracoes > Geral > Modulos da conta. A lista
// corrida de 26 chaves obrigava a ler tudo para achar um modulo; agrupar por
// area (IA, Atendimento, Funil, Canais) reduz a leitura. Modulo novo que nao
// entrar aqui cai em "Outros" no fim, e o spec avisa que falta a area.
export const MODULE_AREAS = [
  {
    id: 'ai',
    modules: [
      'ai_agent',
      'ai_action_center',
      'ai_center_kanban',
      'ai_center_social',
      'ai_center_opportunities',
      'ai_center_conversions',
      'ai_center_copilot',
      'ai_center_calls',
      'instagram_ai_engagement',
      'lead_scoring',
      'imoveis_suggestion',
      'real_estate_module',
    ],
  },
  {
    id: 'service',
    modules: [
      'conversation_header_v3',
      'lead_context_panel',
      'lead_context_hermes',
      'lead_origin_marker',
      'contact_identities',
      'jornada_360',
      'conversation_required_attributes',
      'advanced_assignment',
      'onboarding_visor',
    ],
  },
  {
    id: 'funnel',
    modules: [
      'funil_daily_summary',
      'funil_forgotten_opportunity',
      'agenda_central',
    ],
  },
  {
    id: 'channels',
    modules: ['whatsapp_groups', 'email_sequences', 'voip_calls'],
  },
];

const OTHER_AREA = 'other';

export const groupModulesByArea = modules => {
  const areaOf = key =>
    MODULE_AREAS.find(area => area.modules.includes(key))?.id || OTHER_AREA;
  const ids = [...MODULE_AREAS.map(area => area.id), OTHER_AREA];

  return ids
    .map(id => ({
      id,
      modules: modules.filter(moduleItem => areaOf(moduleItem.key) === id),
    }))
    .filter(area => area.modules.length > 0);
};
